import DesignationsPage from "./pages/DesignationsPage";
import DesignationDetailsPage from "./pages/DesignationDetailsPage";

/** Gated on the privilege — see the note in chapter/routes.tsx. */
export const designationsRoutes = [
  { path: "/designations", element: <DesignationsPage />, perms: ["designation.access"] },
  {
    path: "/designations/:id",
    element: <DesignationDetailsPage />,
    perms: ["designation.access"],
  },
];
